import React, { FC } from "react";

import { List, ListItem, ListItemText, Divider } from "@mui/material";

import { useAppDispatch, useAppSelector } from "store";
import { toggleSidebar } from "store/modules/layout";
import { useAuthentication } from "context/AuthenticationProvider";
import { useMobile } from "hooks/useMobile";
import { history } from "configs";
import { useConfirmDialog } from "hooks/useDialogConfirm";

export const Profile: FC = () => {
  const { escola } = useAppSelector((state) => state);

  const isMobile = useMobile();
  const dispatch = useAppDispatch();

  const { AuthenticatedUserComponent, signOut } = useAuthentication();

  const { show: showSair, RenderDialog: DialogSair } = useConfirmDialog({
    defaults: {
      title: "Sair da aplicativo",
      content: "Tem certeza que deseja sair do aplicativo?",
    },
    onConfirmed: () =>
      signOut({
        after: () => window.location.reload(),
      }),
  });

  return (
    <List>
      <DialogSair />
      <ListItem>
        <ListItemText primary={escola.nome} />
      </ListItem>
      <Divider />
      <AuthenticatedUserComponent
        showSignOutBtn
        onClick={() => {
          if (isMobile) {
            dispatch(toggleSidebar());
          }
          history.push("/profile/");
        }}
        signOutAction={() => showSair(true)}
      />
      <Divider />
    </List>
  );
};
